<script setup lang="ts">
import { format } from "date-fns"
import { useForm } from "@inertiajs/vue3"
import { computed, ref, watch } from "vue"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog"
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, SelectGroup } from "@/components/ui/select"
import { Separator } from "@/components/ui/separator"
import { useToast } from "@/components/ui/toast/use-toast"
import { links } from "@/store"

const { toast } = useToast()
const open = ref(false)
const $file = ref()
const form = useForm({
    file: null as File | null,
})

function handleFileChange(e: Event) {
  const target = e.target as HTMLInputElement
  if (target.files && target.files.length > 0) {
    form.file = target.files[0] // assign the file object
  } else {
    form.file = null
  }
}

function submit() {
    form.post(links.value.transactions.import_path, {
        forceFormData: true,
        onSuccess() {
            form.reset()
            open.value = false

            toast({
                description: "Transactions successfully imported!",
            })
        },
    })
}
</script>

<template>
    <Dialog v-model:open="open">
        <DialogTrigger as-child>
            <Button> Import transaction </Button>
        </DialogTrigger>
        <DialogContent class="sm:max-w-[625px]">
            <form :action="links.transactions.import_path" @submit.prevent="submit" method="POST" enctype="multipart/form-data">
                <input type="hidden" name="_token" value="" />

                <DialogHeader>
                    <DialogTitle>Import Transactions</DialogTitle>
                    <DialogDescription>Upload a CSV with date, type, description, and amount columns. Optional columns: branch_id and or_number. Import each file only once.</DialogDescription>
                </DialogHeader>
                <div class="grid gap-4 py-4">
                    <div class="flex space-x-4">
                        <FormField name="file">
                            <FormItem :error="form.errors.file">
                                <FormLabel>File</FormLabel>
                                <FormControl>
                                    <Input type="file" name="file" accept=".csv" ref="$file" @change="handleFileChange" />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        </FormField>
                    </div>
                </div>
                <Separator class="my-6" />
                <DialogFooter class="flex sm:justify-between">
                    <div class="[ flex gap-2 items-center ml-auto ]">
                        <Button type="submit" :disabled="form.processing || !form.file">{{ form.processing ? "Importing…" : "Import" }}</Button>
                    </div>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>
</template>
